import { GridOffset } from "@insite/mobius/GridContainer";
import { RadioStyle } from "@insite/mobius/Radio";
import { checkoutShippingCarrierServiceStyles as styles } from "@waytek/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCarrierService";
import { fontFamily, mediaQueriesBP } from "@waytek/Utilities/variables";
import { checkoutInputSelectorStyling } from "@waytek/WidgetExtensions/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPageContainer";
import { css } from "styled-components";

styles.container = {
    gap: 20,
    css: css`
        & > ${GridOffset} {
            justify-content: space-between;
            &&& {
                max-width: calc(100% + 20px);
            }
        }
    `,
};
styles.shippingGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
        padding-bottom: 10px;
    `,
};

styles.shippingHeading = {
    as: "h2",
    variant: "body",
    fontFamily,
    size: "18px",
    lineHeight: "32px",
    weight: 700,
    css: css`
        margin-bottom: 4px;
    `,
};

styles.noCarriersFoundToaster = {
    css: css`
        margin: 0;
        width: 100%;
        box-shadow: none;
    `,
};

styles.carrierGridItem = {
    ...styles.carrierGridItem,
    width: [12, 12, 6, 4, 4],
    css: css`
        ${mediaQueriesBP.minLG} {
            && {
                max-width: 230px;
            }
        }
    `,
};

styles.carrierGridItemWithDate = {
    ...styles.carrierGridItemWithDate,
    width: [12, 12, 6, 6, 4],
};

styles.carrierSelect = {
    ...styles.carrierSelect,
    mergeCss: true,
    ...checkoutInputSelectorStyling(styles.carrierSelect),
};
styles.carrierRadioGroup = styles.serviceRadioGroup = {
    mergeCss: true,
    css: css`
        & > ${RadioStyle} {
            display: inline-flex;
            input[type="radio"] {
                margin: 0;
            }
        }
    `,
};

styles.serviceGridItem = {
    ...styles.serviceGridItem,
    width: [12, 12, 6, 4, 4],
};

styles.serviceGridItemWithDate = {
    ...styles.serviceGridItemWithDate,
    width: [12, 12, 6, 6, 4],
};

styles.serviceSelect = {
    ...styles.serviceSelect,
    mergeCss: true,
    ...checkoutInputSelectorStyling(styles.serviceSelect),
};

styles.serviceSelectLink = {
    typographyProps: {
        css: css`
            font-size: 12px;
            line-height: normal;
        `,
    },
};

styles.deliveryDateGridItem = {
    ...styles.deliveryDateGridItem,
    width: [12, 12, 12, 4, 4],
    css: css`
        gap: 20px;
    `,
};

styles.deliveryDateGridItemWithDate = {
    ...styles.deliveryDateGridItemWithDate,
    width: [12, 12, 12, 12, 4],
    css: css`
        gap: 16px;
        flex-direction: column;
    `,
};

styles.pickUpDateGridItem = {
    ...styles.pickUpDateGridItem,
    width: [12, 12, 6, 4, 4],
};

styles.deliveryDatePicker = {
    ...styles.deliveryDatePicker,
    clearIconProps: {
        css: css`
            display: none;
        `,
    },
    ...checkoutInputSelectorStyling(styles.deliveryDatePicker),
    cssOverrides: {
        ...checkoutInputSelectorStyling(styles.deliveryDatePicker).cssOverrides,
        formField: css`
            ${styles.deliveryDatePicker?.cssOverrides?.formField}
            min-width: 160px;
            margin-right: 23px;
        `,
    },
};

styles.mapModal = {
    size: 640,
    cssOverrides: {
        modalContent: css`
            && {
                padding: 20px 18px 21px 22px;
            }
        `,
    },
};

styles.mapModalContentWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

styles.mapModalSubheadingTypography = {
    size: "18px",
    weight: 700,
    lineHeight: "32px",
};

styles.mapModalDivider = {
    css: css`
        margin-top: 4px;
    `,
};

styles.mapModalImage = {
    css: css`
        margin-top: 20px;
        display: inline-flex;
    `,
};

styles.mapModalImg = {
    css: css`
        width: 100%;
        height: auto;
    `,
};

styles.mapModalContent = {
    css: css`
        margin-top: 17px;
    `,
};

styles.shippingRatesToaster = {
    css: css`
        && {
            margin: 0;
            width: 100%;
            box-shadow: none;
        }
    `,
};
styles.serviceRadioWrapper = {
    css: css`
        display: block;
    `,
};
styles.serviceRadioPrice = {
    css: css`
        white-space: nowrap;
        font-weight: bold;
        font-size: 14px;
        margin-left: 12px;
    `,
};
